export { default as ButtonOBSOLETED } from './_Button';
export * from './_allowedPropTypes';